import images from './images'

const logo = [
  {
    logo: images.logo,
  },
]
const wallpaper = [
  {
    wallpaper: images.wallpaper,
  },
]
const grids = {
  escobaria: [images.escobaria, images.escobaria_2], // Images for escobaria
  laxmi_kamal: [
    images.laxmi_kamal,
    images.laxmi_kamal2,
    images.laxmi_kamal3,
    images.laxmi_kamal4,
    images.laxmi_kamal5,
    images.laxmi_kamal6,
  ], // Images for laxmi_kamal
  snake: [images.snake1, images.snake2, images.snake3], // Images for snake
  money: [images.money, images.money2, images.money3, images.money4], // Images for money
  bunnyears: [images.bunnyears, images.bunnyears2, images.bunnyears3, images.bunnyears4], // Images for Bunnyears
  stonecrop: [
    images.stonecrop,
    images.stonecrop2,
    images.stonecrop3,
    images.stonecrop4,
  ], // Images for stonecrop
  bunnyears_yellow: [
    images.bunnyears_yellow,
    images.bunnyears_yellow2,
    images.bunnyears_yellow3,
  ], // Images for supplera
  supplera: [
    images.supplera,
    images.supplera2,
  ], // Images for Bunnyears_yellow
  kalanchoe: [
    images.kalanchoe,
    images.kalanchoe2,
  ], // Images for Bunnyears_yellow
  guldavari: [
    images.guldavari,
    images.guldavari2,
    images.guldavari3,
  ], // Images for guldavari
  tulsi: [
    images.tulsi
  ], // Images for tulsi
}
export default { logo, grids, wallpaper }
